module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-inner"
  }, [_c('div', {
    staticClass: "footer-mobile"
  }, [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-expansion-panels', {
    attrs: {
      "accordion": "",
      "tile": "",
      "flat": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title-footer"
  }, [_vm._v("О НАС")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('ul', {
    staticClass: "panel__content"
  }, [(_vm.getTemplate) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getTemplate.hb1)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getTemplate.hb1, 'hb1')
      }
    }
  }) : _vm._e()])])], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title-footer"
  }, [_vm._v("ЛЕЧЕНИЕ АЛКОГОЛИЗМА")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('ul', {
    staticClass: "panel__content"
  }, [(_vm.getTemplate) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getTemplate.hb2)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getTemplate.hb2, 'hb2')
      }
    }
  }) : _vm._e()])])], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title-footer"
  }, [_vm._v("\n                            ЛЕЧЕНИЕ НАРКОМАНИИ\n                        ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('ul', {
    staticClass: "panel__content"
  }, [(_vm.getTemplate) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getTemplate.hb3)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getTemplate.hb3, 'hb3')
      }
    }
  }) : _vm._e()])])], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title-footer"
  }, [_vm._v("\n                            ВСЕ ГОРОДА\n                        ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('ul', {
    staticClass: "panel__content"
  }, _vm._l((_vm.getCityList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      staticClass: "tex-footer",
      attrs: {
        "href": 'https://' + item.domain,
        "route": "ignore",
        "target": "_blank"
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])])
  }), 0)])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-info",
    attrs: {
      "cols": "12"
    }
  }, [(_vm.getTemplate) ? _c('span', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getTemplate.hb5)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getTemplate.hb5, 'hb5')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "footer__mobile-social"
  }, [(_vm.getTemplate) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getTemplate.hb4)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getTemplate.hb4, 'hb4')
      }
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "footer__item footer__form-u",
    attrs: {
      "cols": "4"
    }
  }, [_c('form', {
    staticClass: "footer-form"
  }, [_c('div', {
    staticClass: "dropdown show"
  }, [_c('a', {
    staticClass: "btn btn-secondary dropdown-toggle city-select",
    attrs: {
      "href": "#",
      "role": "button",
      "id": "dropdownMenuLink",
      "route": "ignore",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                        Все города\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "dropdownMenuLink"
    }
  }, [_vm._l((_vm.getCityList), function(item, index) {
    return [_c('a', {
      key: index,
      staticClass: "dropdown-item",
      attrs: {
        "href": 'https://' + item.domain,
        "route": "ignore",
        "target": "_blank"
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])]
  })], 2)])]), _vm._v(" "), _c('p', {
    staticClass: "text-info"
  }, [(_vm.getTemplate) ? _c('span', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getTemplate.hb5)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getTemplate.hb5, 'hb5')
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    staticClass: "footer__item footer__medium-menu-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('ul', {
    staticClass: "footer__item-list-top"
  }, [_c('li', [_c('a', {
    staticClass: "title-footer",
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("\n                        О НАС\n                    ")])]), _vm._v(" "), (_vm.getTemplate) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getTemplate.hb1)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getTemplate.hb1, 'hb1')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "footer__item-list-top"
  }, [_c('li', [_c('a', {
    staticClass: "title-footer",
    attrs: {
      "href": "/narkomania"
    }
  }, [_vm._v("\n                        ЛЕЧЕНИЕ НАРКОМАНИИ\n                    ")])]), _vm._v(" "), (_vm.getTemplate) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getTemplate.hb3)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getTemplate.hb3, 'hb3')
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    staticClass: "footer__item footer__medium-menu-3",
    attrs: {
      "cols": "3"
    }
  }, [_c('ul', {
    staticClass: "footer__item-right"
  }, [_c('li', [_c('a', {
    staticClass: "title-footer",
    attrs: {
      "href": "/alcogolizm"
    }
  }, [_vm._v("\n                        ЛЕЧЕНИЕ АЛКОГОЛИЗМА\n                    ")])]), _vm._v(" "), (_vm.getTemplate) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getTemplate.hb2)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getTemplate.hb2, 'hb2')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "footer__item-right-bottom"
  }, [(_vm.getTemplate) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getTemplate.hb6)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getTemplate.hb6, 'hb6')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "footer__medium-social"
  }, [(_vm.getTemplate) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getTemplate.hb4)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getTemplate.hb4, 'hb4')
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    staticClass: "footer__social",
    attrs: {
      "cols": "1"
    }
  }, [(_vm.getTemplate) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getTemplate.hb4)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getTemplate.hb4, 'hb4')
      }
    }
  }) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4da2e341","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/footer.vue
// module id = 129
// module chunks = 2